<form [formGroup]="updateChargesForm" (submit)="onUpdateCharges()">
    <div class="row">
        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12">
            <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h3 class="card-title mb-0">Update Astrologer Charges</h3>

                    <ng-select [items]="dataList" bindLabel="countryName" bindValue="_id" placeholder="Select Country"
                        (change)="getValue($event)" class="mb-0" [searchable]="true" style="width: 300px;">

                        <ng-template ng-label-tmp let-item="item">
                            {{ item.countryName }} ({{ item.countryCode }})
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item">
                            {{ item.countryName }} ({{ item.countryCode }})
                        </ng-template>

                    </ng-select>

                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-md-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Call Charges ({{ internationalCallPrice }})</mat-label>
                                <input matInput type="number" placeholder="Call Charges"
                                    formControlName="call_charges" />
                                <mat-error
                                    *ngIf="f.call_charges.invalid && (f.call_charges.dirty || f.call_charges.touched)">
                                    Required
                                </mat-error>
                            </mat-form-field>
                        </div>


                    </div>

                    <div class="row">
                        <div class="col-lg-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Chat Charges ({{ internationalChatPrice }})</mat-label>
                                <input matInput type="number" placeholder="Chat Charges"
                                    formControlName="chat_charges" />
                                <mat-error
                                    *ngIf="f.chat_charges.invalid && (f.chat_charges.dirty || f.chat_charges.touched)">
                                    Required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Query Charges ({{ internationalQueryPrice }})</mat-label>
                                <input matInput type="number" placeholder="Query Charges"
                                    formControlName="query_charges" />
                                <mat-error
                                    *ngIf="f.query_charges.invalid && (f.query_charges.dirty || f.query_charges.touched)">
                                    Required
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Report Charges ({{ internationalReportPrice }})</mat-label>
                                <input matInput type="number" placeholder="Report Charges"
                                    formControlName="report_charges" />
                                <mat-error
                                    *ngIf="f.report_charges.invalid && (f.report_charges.dirty || f.report_charges.touched)">
                                    Required
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- <div class="col-lg-6 col-md-12">
                            <div class="form-group">

                                <div class="col-xl-12 col-lg-12 col-md-12 p-0">
                                    <input type="checkbox" name="" id="" class="mr-2" formControlName="is_promotional_allow" (change)="togglePermotionalDeatails($event)">
                                    <label>Allow Permotional Calls</label>
                                </div>
                                <div *ngIf="f.is_promotional_allow.invalid && (f.is_promotional_allow.dirty || f.is_promotional_allow.touched)" class="alert alert-danger mt-1">
                                    Required
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12" *ngIf="permotionalAllow">
                            <div class="form-group">
                                <label >Permotional Call Charges</label>
                                <input type="number" class="form-control"
                                    placeholder="Permotional Call Charges" formControlName="promocall_totake">
                                <div *ngIf="f.promocall_totake.invalid && (f.promocall_totake.dirty || f.promocall_totake.touched)" class="alert alert-danger mt-1">
                                    Required
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="card-footer d-flex justify-content-center">
                    <button type="submit" class="col-sm-4 btn btn-success mt-1">Save</button>
                    <!--<button class="btn btn-danger mt-1 ml-2">Cancel</button>-->
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Charges Update Logs</h3>
                </div>
                <div class="card-body">
                    <ngx-datatable class="material" [rows]="chargeLogs" [columnMode]="'force'" [headerHeight]="50"
                        [footerHeight]="50" [rowHeight]="'auto'" [scrollbarV]="false" [limit]="10"
                        [sorts]="[{dir: 'desc'}]" style="position: relative !important;">
                        <ngx-datatable-column [flexGrow]="1" name="Charges" prop="last_charge">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{row.last_charge | currency:'INR':'symbol-narrow'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [flexGrow]="1" name="Updated Charges" prop="new_charge">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{row.new_charge | currency:'INR':'symbol-narrow'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [flexGrow]="1" name="Type" prop="charge_type">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="text-uppercase rounded-1 px-1 text-bg-primary">{{row.charge_type}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [flexGrow]="1" name="Status">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="rounded-1 px-1 text-bg-warning" *ngIf="row.is_new_request">Pending</span>
                                <span class="rounded-1 px-1 text-bg-success"
                                    *ngIf="!row.is_new_request && row.change_approved">Approved</span>
                                <span class="rounded-1 px-1 text-bg-primary"
                                    *ngIf="!row.is_new_request && !row.change_approved">Rejected</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [flexGrow]="3" name="Astro Remarks">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{row.change_comment}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [flexGrow]="2" name="Updated At">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{row.updatedDate | date:'medium'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [flexGrow]="2" name="Action At">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                @if (row.approvalDate) {
                                {{ row.approvalDate | date: 'medium' }}
                                } @else {
                                -
                                }

                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>

    </div>
</form>
